import { getFieldsToValidateByStep } from './getFieldsToValidateByStep';

export function getPreviousErrorsByStep({
  steps,
  currentStep,
  errors,
}: // oxlint-disable-next-line typescript/no-explicit-any
any): string[][] {
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-argument
  const errorsByStep = getFieldsToValidateByStep(steps, currentStep - 1);

  return errorsByStep.map((step) =>
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line @typescript-eslint/no-unsafe-argument
    Object.keys(errors).filter((errorName) => step.includes(errorName)),
  );
}
